import React, { lazy, Suspense } from 'react';

const LazyVehicleHistoryPage = lazy(() => import('./VehicleHistoryPage'));

const VehicleHistoryPage = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyVehicleHistoryPage {...props} />
  </Suspense>
);

export default VehicleHistoryPage;
